import React, {useEffect} from 'react';

import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Divider from '@mui/joy/Divider';
import Input from '@mui/joy/Input';

import IcoPercent from '@mui/icons-material/Percent';



export default function TrendBased(props) {
	var perc = React.useRef(0);
	var sma = React.useRef("");

	useEffect(() => {
		props.handleClick(props.activeCard && perc > 0 && sma != "", perc, sma);			
	}, [props.activeCard]);

	function handleInputChange(e) {
		var isValid = false;
	
		if (e.target.value != undefined)
			perc.current = e.target.value;
		
		isValid = perc.current > 0 && sma.current != "";
		
		props.handleClick(props.activeCard && isValid, perc.current, sma.current);
	}
	
	function handleSelectChange(e, val) {
		var isValid = false;

		if (val != undefined)
			sma.current = val;
			
		isValid = perc.current > 0 && sma.current != "";
		
		props.handleClick(props.activeCard && isValid, perc.current, sma.current);
	}	

	return (		
		<Input type="number" autoFocus disabled={!props.activeCard} size="lg" startDecorator={<IcoPercent />} 
			endDecorator={
				<React.Fragment>
					<Divider orientation="vertical" />
					<Select
					  variant='plain'
					  size="lg"
					  disabled={!props.activeCard}
					  placeholder="Moving average"
					  onChange={handleSelectChange}
					  slotProps={{
					    listbox: {
					      variant: 'outlined',
					    },
					  }}
					  sx={{ mr: -1.5, '&:hover': { bgcolor: 'transparent' } }}
					>
						<Option value="SMA20">SMA20</Option>
						<Option value="SMA50">SMA50</Option>
						<Option value="SMA200">SMA200</Option>
					</Select>
				</React.Fragment>
			}								
 			onChange={(e) => {handleInputChange(e);}} onWheel={(e) => e.target.blur()}
		/>				        	
	)
}

